module.exports = __webpack_public_path__ + "img/logo.be12d73a.png";